import { useQuery } from '@tanstack/react-query'
import httpClient from '~/modules/core/httpClient'

const checkCanfleetUser = (storeId: string, email: string) =>
  httpClient.json.get(
    `/canfleet/check-user-exist?email=${encodeURIComponent(email)}&store_id=${storeId}`,
  )

export const useCheckCanfleetUser = (
  storeId: string,
  email: string,
  enabled = true,
) =>
  useQuery({
    queryKey: ['checkCanfleetUser', storeId, email],
    queryFn: () => checkCanfleetUser(storeId, email),
    initialData: { userExistsInCf: false },
    select: (res) => ({
      userExistsInCf: !!res?.user_exists_in_cf,
      cfOrgId: res?.cf_org_id,
    }),
    enabled: !!storeId && !!email && enabled,
  })
